var exports = {
  "n": "PerksButton.module__link___TDdKVF",
};

module.exports = exports;
